import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Clock, ExternalLink } from 'lucide-react';

import LanguagePicker from '../../components/LanguagePicker';
import flexbeeLogo from '../../assets/media/flexbee-no-bg.webp';
import { LIVE_SANDBOX_TAB_URL } from '../../utils/environment';
import {
  PageWrapper,
  LanguagePickerWrapper,
  FormCard,
  LogoContainer,
  FormTitle,
  FormSubtitle,
  InfoMessage,
  GradientLinkButton,
} from './styles';

// Test ortamının (REACT_APP_ENVIRONMENT=sandbox) giriş ekranı — parola formunun YERİNE.
// Test ortamına parolayla girilmez (tasarım belgesi K4: canlı panel kimlik sağlayıcıdır; sunucu
// parola uçlarını 403 sandbox.passwordLoginDisabled ile kapatır). Kullanıcı canlı panele, oradaki
// Entegrasyonlar > Test Ortamı sekmesine yönlendirilir. Parola / "şifremi unuttum" bağlantısı YOK.
const Steps = styled.ol`
  margin: 0 0 24px;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.45;
`;

export default function SandboxLoginNotice({ idleReason = false }) {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <LanguagePickerWrapper>
        <LanguagePicker />
      </LanguagePickerWrapper>
      <FormCard data-role="sandbox-login-notice">
        <LogoContainer>
          <img src={flexbeeLogo} alt="Flexbee" />
        </LogoContainer>
        <FormTitle>{t('sandboxEnv.login.title')}</FormTitle>
        <FormSubtitle>{t('sandboxEnv.login.subtitle')}</FormSubtitle>
        {idleReason && (
          <InfoMessage role="status" data-testid="idle-logout-notice">
            <Clock size={16} />
            <span>{t('session.idleLoggedOut')}</span>
          </InfoMessage>
        )}
        <Steps>
          <li>{t('sandboxEnv.login.step1')}</li>
          <li>{t('sandboxEnv.login.step2')}</li>
          <li>{t('sandboxEnv.login.step3')}</li>
        </Steps>
        <GradientLinkButton as="a" href={LIVE_SANDBOX_TAB_URL} data-role="sandbox-login-panel-link">
          <ExternalLink size={18} />
          {t('sandboxEnv.login.openPanel')}
        </GradientLinkButton>
      </FormCard>
    </PageWrapper>
  );
}
